import { apiRequest } from "../util/apiUtils";

export const eligibilityList = async (params) => {
  try {
    const res = await apiRequest("get", `eligibility/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const eligibilityAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `eligibility/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const eligibilityDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `eligibility/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const eligibilityStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `eligibility/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const eligibilityOrder = async (payload) => {
  try {
    const res = await apiRequest("patch", `faq/ordering`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
